import React from 'react';
import PropTypes from 'prop-types';
import { Pagination } from 'react-bootstrap';

class PageChanger extends React.Component {
  numberPages () {
    // Get 2 pages before and after current page
    let pages = [];
    for (let i = Math.max(1, this.props.currentPage - 2); i <= Math.min(this.props.pages, this.props.currentPage + 2); i++) {
      pages.push(i);
    }
    return pages;
  }

  render () {
    return (
      <Pagination className="float-right mr-4">
        <Pagination.First onClick={() => this.props.handlePages(1)} />
        <Pagination.Prev onClick={() => this.props.handlePages(Math.max(this.props.currentPage - 1, 1))} />
        { this.numberPages().map((index) => (
          <Pagination.Item key={index} active={index === this.props.currentPage} onClick={() => this.props.handlePages(index)}>
            {index}
          </Pagination.Item>
        )) }
        <Pagination.Next onClick={() => this.props.handlePages(Math.min(this.props.currentPage + 1, this.props.pages))} />
        <Pagination.Last onClick={() => this.props.handlePages(this.props.pages)} />
      </Pagination>
    );
  }
}

PageChanger.propTypes = {
  handlePages: PropTypes.func,
  currentPage: PropTypes.number,
  pages: PropTypes.number
};

export default PageChanger;
